import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { designSystem, reactHookForm } from '@yola/ws-ui';
import getFieldsByServiceName from './helpers/get-fields-by-service-name';
import getFieldsWithSubFields from './helpers/get-field-with-subfields';

const { Stack } = designSystem;
const { useWatch } = reactHookForm;

const DifmBannerSurvey = ({ getValues, serviceName, control }) => {
  const values = getValues();
  const currentFields = useMemo(() => getFieldsByServiceName(serviceName) || [], [serviceName]);

  const watchedFields = getFieldsWithSubFields(currentFields);

  // Watch for changes in the form to trigger re-render & show\hide subfields
  useWatch({ control, name: watchedFields });
  const renderFields = useCallback((fields, fieldValues) => {
    const extractFieldToList = (fieldProps = {}, list = []) => {
      const fieldValue = fieldValues[fieldProps.name];
      const value = Array.isArray(fieldValue)
        ? fieldValue.find((val) => val === 'Other')
        : fieldValue;
      const subField = value && fieldProps.subFields && fieldProps.subFields[value];

      const newList = [...list, fieldProps];

      if (subField) {
        // Recursively call function to get sub field
        return extractFieldToList(subField, newList);
      }

      return newList;
    };

    const fieldList = fields.reduce((acc, field) => [...acc, ...extractFieldToList(field)], []);

    return (
      <Stack gap="spacing-2-xs">
        {fieldList.map(({ Component, ...fieldProps }) => (
          <Component key={fieldProps.name} control={control} {...fieldProps} values={fieldValues} />
        ))}
      </Stack>
    );
  }, []);

  return renderFields(currentFields, values);
};

DifmBannerSurvey.propTypes = {
  serviceName: PropTypes.string.isRequired,
  getValues: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
};

export default DifmBannerSurvey;
